import { render, staticRenderFns } from "./EditPermission.vue?vue&type=template&id=6c26b5a5&"
import script from "./EditPermission.vue?vue&type=script&lang=js&"
export * from "./EditPermission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports